import axios from "axios";
import {createAsyncThunk} from "@reduxjs/toolkit";
import { baseUrl } from "config";



const getPrivileges=createAsyncThunk("getprivileges",async ()=>{
    const res=await  axios.get(
        baseUrl + "/get-privileges-for-erp",
        { withCredentials: true }
      )
    return res.data.data
})


export {getPrivileges}